module.exports = {
    options: {
        language: 'Language',
        zh: 'Chinese',
        en: 'English',
        jp: 'Japanese',
        nodata: 'No Data',
        addSucccess: 'Added Successfully',
        succcess: 'Operate Successfully',
        more: 'More',
        recommend: 'Recommend',
        text1: 'Confirm the quotation of this hotel.',
        text2: 'Confirm',
        text3: 'Cancel',
        text4: 'Reminder',  // reminder
        text5: 'Adopt successfully',  // reminder
        text6: 'The meeting demand has been successfully released.',
        text7: 'This meeting room does not support the placement of this table type..',
        text8: "Without",
        ok: "OK",
        cancel: "Cancel",
        tip: "Tip",
    },
    header: {
        home: 'Home',
        meetingVenue: 'Meeting Venue',
        service: 'Service',
        cyclopedia: 'CSR Project Center',
        jion: 'Join Us',
        abputUs: 'About Us',
        memberCenter: 'MemberCenter',
        userInfo: 'UserInfo',
        applicationCenter: 'Applications',
        cooperative: 'Cooperative',
        supplier: 'Supplier',
    },
    order: {
        all: 'All',
        submitted: 'Submitted',
        obtained: 'Plan Obtained', // The plan has been obtained.
        communicate: 'Communicate', // The plan has been obtained.
        reserved: 'Reserved',
        completed: 'Completed',
        cancelled: 'Cancelled',

        confirmed: 'Confirmed',
        verify: 'Verified',
        selected: 'Selected',
        communication: 'Pending Communication',
        bargain: 'Pending Deal',
        settle: 'Pending Settlement',
        closedAccount: 'Settled',
        process: 'Stop Bidding'
    },
    bottom_nav: {
        text1: 'About Us',
        text2: 'Company Profile',
        text3: 'Contact Us',
        text4: 'Join Us',
        text5: 'Partner With Us',
        text6: 'Settled platform',
        text7: 'Supporting Service Provider Registration',
        text8: 'Help Center',
        text9: 'Forgot Password',
        text10: 'FAQs',
        text11: 'Business Cooperation',
        text12: 'Infringement/Complaint',
        text13: 'WeChat',
        text14: 'National Hotline',
        text15: 'Online Consultation',
        text16: 'Suzhou Xingtianyue Digital Technology Co., Ltd.',
        text17: 'Room 4010, Xiegang Plaza, No. 99 Xiqing Road, Suzhou',
        text18: 'Global Meeting Industry Chain Hotel Direct Procurement Platform',
        text19: 'Su ICP No. 2025174180-1'
    },
    bottom_page: {
        text1: 'Customized Service Process',
        text2: 'Release Meeting in 1 Minute',
        text3: 'Fill in Basic Meeting Requirements',
        text4: 'Consultant Calls in 10 Minutes',
        text5: 'Dedicated Consultant 1v1 Follow-up',
        text6: 'Get Meeting Plan in 30 Minutes',
        text7: 'Screen Plans, Intelligent Matching',
        text8: 'Book Venue Visit',
        text9: 'Highly Matched Real Scene',
        text10: 'Event Concludes Successfully',
        text11: 'Full Process Service Ensures Quality',
    },
    citySelect: {
        text1: 'Please enter city name',
    },
    aboutUs: {
        text1: 'Company Overview',
        text2: 'Meetingtrips is committed to providing enterprises with one-stop meeting services. With highly integrated resources, professional management, and attentive service,\n' +
            'we assist clients in enhancing meeting quality, creating meeting value, and achieving meeting objectives.',
        text3: 'Learn More',
        text4: 'Development History',
        text5: 'The development and growth of Meetingtrips are like the earth and its roots. Beneath the surging waves of the long river lies silent accumulation; each breakthrough hides the light precipitated over the years.',
        text6: 'Learn More',
        text7: 'Investor Relations',
        text8: 'Amidst risks and opportunities, we must keenly capture the glimmer of industry trends while anchoring ourselves to the coordinates of long-term value amidst cyclical fluctuations.\n' +
            'Every decision is a fulfillment of cognition; every wait is a covenant made with time.',
        text9: 'Learn More',
        text10: 'Strategic Partners',
        text11: 'Meetingtrips has direct procurement resources from 3000+ global hotels, direct connections to 30,000+ resources, and deep collaborations with renowned hotels worldwide, covering all core areas.',
        text12: 'Learn More',
        text13: 'City Partner Program',
        text14: 'In the rapidly developing business tide, we sincerely invite you to join the "City Partner Program" to jointly explore the market and win the future! As a City Partner, you will receive brand support, high-quality resources, professional training, and a generous reward mechanism, becoming our strategic partner in the local market.',
        text15: 'Join us, ignite city business opportunities with partnership! One city, one partner, together we achieve infinite possibilities!',
    },
    appCenter: {
        text1: 'Meetingtrips Global Meeting Industry Chain Hotel Direct Procurement Platform',
        text2: 'Enhance Meeting Quality',
        text3: 'Create Meeting Value',
        text4: 'Achieve Meeting Objectives',
        text5: 'Hotel Service Center',
        text17: '酒店服务中心',  // Here -- Using English as requested for en file
        text6: 'Hotels,Conference Centers,Olympic Sports Centers,Special Venues',
        text7: 'Customer Service Center',
        text18: '客户服务中心',  // Here -- Using English as requested for en file
        text8: 'One-stop meeting service',
        text9: 'Matching service Center',
        text19: '配套服务中心',  // Here -- Using English as requested for en file
        text10: 'Meeting Planning,Equipment Rental,Advertising Materials,Performance Agencies,Security Services',
        text11: 'Tourism Service Center',
        text20: '旅游服务中心',  // Here -- Using English as requested for en file
        text12: 'Travel Consultation,Travel Planning,Tour Guide Services,Training Expansion,Training, Study Tours',
        text13: 'Ticketing Service Center',
        text21: '票务服务中心',  // Here -- Using English as requested for en file
        text14: 'Itinerary Planning,Ticket Booking,Refunds & Changes,Vehicle Services,Butler Services',
        text15: 'Wedding Service Center',
        text22: '婚庆服务中心',  // Here -- Using English as requested for en file
        text16: 'Wedding Planning,Wedding Execution, Photography Videography,Styling,Honeymoon',
    },
    appCenter_service: {
        text1: 'Meeting Support Services',
        text2: 'Efficiently and Simply Solve Meeting Needs',
        text3: 'Your Mobile Number',
        text4: 'SMS Verification Code',
        text5: 'Get Verification Code',
        text6: 'Free Appointment Application',
        text7: 'Carefully Selected Meeting Support Services',
        text8: 'Wonderful Event Cases',
        text9: 'Hot Line',
        text10: 'Call',
        more: 'More',

        text11: 'Tourism Service Center',
        text12: '旅游服务中心', // Here -- Using English as file indicates
        text13: 'Travel Consultation, Travel Planning, Tour Guide Services',

        text14: 'Ticketing Service Center',
        text15: '票务服务中心', // Here -- Using English as file indicates
        text16: 'Itinerary Planning, Ticket Booking, Refunds & Changes',

        text17: 'Wedding Service Center',
        text18: '婚庆服务中心', // Here -- Using English as file indicates
        text19: 'Wedding Planning, Wedding Execution, Honeymoon Planning',

        text20: 'Creative Planning',
        text21: 'Provides full-process meeting planning solutions',

        text22: 'Stage Setup',
        text23: 'Professional team ensures smooth event execution',

        text24: 'Photography & Videography',
        text25: 'Live Streaming, Editing, Audio/Video Processing',

        text26: 'Simultaneous Interpretation',
        text27: 'Accurate, efficient multilingual information delivery',

        text29: 'Advertising Production',
        text30: 'Provides optimal materials, event image',

        text31: 'Performance Services',
        text32: 'Adds vitality and highlights to meetings & events',

        text33: 'Vehicle Services',
        text34: 'Provides safe, punctual, comfortable service',

        text35: 'Gift Customization',
        text36: 'Elevates event theme and image',

        text37: 'Audi New Car Exhibition',
        text38: 'Chilean Koyle Winery Tasting Event',
        text39: 'China Fishing Masters Tour',
        text40: 'Meiao Oral Public Welfare Event',

        text41: 'Affiliated Unit',
        text42: 'Country',
        text43: 'Business License',
        text44: 'Username',
        text45: 'Password',
        text49: 'Confirm Password',
        text46: 'Mobile Number',
        text47: 'Verification Code',
        text48: 'Email',
        text50: 'Upload',
        text51: 'Please upload an image',
        text52: 'Send Verification Code',
        text53: 'Submit',
        text54: 'Cancel',
        text55: 'Please enter password',
        text56: 'Please confirm that the two passwords are consistent',
        text57: 'Supplier Registration',
        text58: 'Please enter {value}',
        text59: 'Please enter a valid mobile number',
        text60: 'Password cannot contain Chinese characters',
        text61: 'Send Success',
        text62: 'Already registered, go to login',
    },
    conferenceSpace: {
        all: 'Unlimited',
        text1: 'Please enter hotel, landmark, business district keywords',
        text2: 'Search',
        text3: 'Hotel',
        text4: 'Location',
        text5: 'Venue Type',
        text6: 'Hotel Brand',
        text7: 'Please enter group or hotel name',
        text8: 'Capacity',
        text9: 'Venue Area',
        text10: 'Number of Twin Rooms',
        text11: 'Style Features',
        text12: 'Venue Price',
        text13: 'Hotel Facilities',

        text14: 'Venue',
        text15: 'Venue Ceiling Height',
        text16: 'Venue Conditions',
        text17: 'Floor Level',
        text18: 'Venue Facilities',

        text30: 'Address',
        text31: 'Area',
        text32: 'Ceiling Height',
        text33: 'Max Capacity',
        text34: 'Height Under Lights',
        text35: 'Length x Width',
        text36: 'Floor',

        text21: 'Home',
        text22: 'Conference Space',
        text23: 'Guest Rooms',
        text24: 'Dining',
        text25: 'Supporting Facilities',
        text26: 'Location & Surroundings',
        text27: 'Gallery',
        text28: 'Event Cases',
        text29: 'Hotel Promotions',

        text37: 'A total of ',
        text38: 'hotels have been found for you.',
        text39: 'meeting venues have been found for you.',
        text40: 'Verification',
        text41: 'Address',
        text42: 'Meeting venue area',
        text43: 'Maximum capacity',
        text44: 'Number of venues',
        text45: 'Number of rooms',
        text46: 'Venue reference price',
        text47: 'Room reference price',
        text48: 'Rooms',
        text49: 'People',
        share: 'Share',
    },
    conferenceSpace_active: {},
    conferenceSpace_canteen: {
        text1: 'Dining',
        text2: 'Total',
        text3: 'Restaurants',
        text4: 'Private Rooms',
        text5: 'Max Dining Area',
        text6: 'Dining Capacity',
        text7: 'Area',
        text8: 'Located On',
        text9: 'Ceiling Height',
        text10: 'Height Under Lights',
        text11: 'Private Rooms',
        text12: 'Units',
        text13: 'Total Seats',
        text14: 'Seats',
        text15: 'Per Capita Consumption',
        text16: 'Business Hours',
    },
    conferenceSpace_facility: {
        text1: 'Supporting Facilities',
        text2: 'Hotel Service Facilities'
    },
    conferenceSpace_home: {
        text1: 'This hotel data has been jointly verified by the hotel and the Meetingtrips platform',
        text2: 'Exterior',
        text3: 'Lobby',
        text4: 'Facilities',
        text5: 'Conference Space',
        text6: 'Guest Rooms',
        text7: 'Restaurant',
        text8: 'Hotel Introduction & Features',
        text9: 'Conference Space',
        text10: 'Rooms',
        text11: 'Guest Rooms',
        text12: 'Largest Venue',
        text13: 'Restaurants',
        text14: 'Max Capacity',
        text15: 'Parking Spaces',
        text16: 'Number of Twin Beds',
        text17: 'Number of King Beds',
        text18: 'Guest Room Reference Price',
        text19: 'Restaurant Cuisine',
        text20: 'Number of Private Rooms',
        text21: 'Hotel Brand',
        text22: 'Opening Date',
        text23: 'Last Renovation',
        text24: 'Conference Space',
        text25: 'Conference Space',
        text26: 'Total',
        text27: 'Venues',
        text28: 'Largest Venue',
        text29: 'Max Capacity',
        text30: 'As',
        text31: 'Meeting Rooms',
        text32: 'Area',
        text33: 'Year',
        text34: 'Max Capacity',
        text35: 'Layout & Capacity',
        text36: 'Reference Price (varies by season, etc.)',
        text37: 'Guest Rooms',
        text38: 'Rooms',
        text39: 'Quantity',
        text40: 'Internet Access',
        text41: 'Window',
        text42: 'Internet Access',
        text43: 'Wi-Fi',
        text44: 'Yes',
        text45: 'No',
        text46: 'Dining',
        text47: 'Private Rooms',
        text48: 'Max Dining Area',
        text49: 'Dining Capacity',
        text50: 'Number of Private Rooms',
        text51: 'Number of Seats',
        text52: 'Per Capita Consumption (varies by season, etc.)',
        text53: 'Length x Width',
        text54: 'Ceiling Height',
        text55: 'Height Under Lights',
        text56: 'CNY',
    },
    conferenceSpace_imagePage: {},
    conferenceSpace_location: {
        text1: 'Location & Surroundings',
        text2: 'Copy Address',
        text3: 'Copied Successfully',
        text4: 'Copy Failed',
    },
    conferenceSpace_promotion: {},
    conferenceSpace_room: {
        text1: 'Guest Rooms',
        text2: 'Rooms',
        text3: 'From',
    },
    conferenceSpace_venue: {
        text1: 'Conference Space',
        text2: 'Total',
        text3: 'Venues',
        text4: 'Largest Venue',
        text5: 'People',
        text6: 'Meeting Rooms',
        text7: 'Area',
        text8: 'Layout & Capacity',
        text9: 'Reference Price (varies by season, etc.)',
        text10: 'Length x Width',
        text11: 'Ceiling Height',
        text12: 'Height Under Lights',
        text13: 'Max Capacity',
        text14: 'Max Capacity',
    },
    conferenceSpace_vanueDetail: {
        text1: 'Area',
        text2: 'Length x Width',
        text3: 'Ceiling Height',
        text4: 'Height Under Lights',
        text5: 'Floor',
        text6: 'Setup & Capacity',
        text7: 'Theater Style',
        text8: 'Classroom Style',
        text9: 'Chinese Banquet',
        text10: 'Western Banquet',
        text11: 'Cocktail Style',
        text12: 'Herringbone/Island',
        text13: 'U-Shape/Hollow Square',
        text14: 'Location & Surroundings',
        text15: 'Copy Address',
        text16: 'Boardroom'
    },
    customer: {
        text1: 'Company Department',
    },
    encyclopedia: {
        text1: 'Posted On',
    },
    loginInterface_loginInterface: {
        text1: 'Hotel & Meeting Venue Registration Guide',
        text2: 'Registration Guide Video',
        text3: 'Meetingtrips Sales Assistant: Hotel Sales Order Taking & Quoting Guide',
        text4: 'Register on Meetingtrips',
        text5: 'Take More',
        text6: 'Meeting Orders',
        text7: 'Efficient Online Order Pushing',
        text8: 'Platform manual review ensures more accurate order pushing',
        text9: 'Convenient APP Order Taking',
        text10: 'Instant order taking via APP & Mini Program',
        text11: 'Intelligent Order Matching',
        text12: 'Quickly match meeting venues based on requirements',
        text13: 'Dedicated Account Manager Service',
        text14: 'Dedicated customer service manager, 1V1 attentive service',
    },
    loginInterface_enterForm: {
        text01: 'get Code',
        text00: 'Resend',
        text000: 's',
        text0: 'Please Select',
        text1: 'Verification Code',
        text2: 'Please Enter',
        text3: 'Your Hotel',
        text4: 'Your Position',
        text5: 'Email Address',
        text6: 'Business Card Information',
        text7: 'Business License',
        text8: 'Name',
        text9: 'Gender',
        text10: 'Male',
        text11: 'Female',
        text12: 'Unknown',
        text13: 'Username',
        text14: 'Mobile Number',
        text15: 'Set Password',
        text16: 'Repeat Password',
        text17: 'Registration Application Successful',
        text18: 'Click to Login',
        text19: 'Back',
        text20: 'Previous',
        text200: 'Next',
        text21: 'Submit Application',
        text22: 'Meetingtrips Hotel Registration Notice',
        text23: 'I. Registration Notes',
        text24: 'Before registering as a Meetingtrips Sales Assistant, please ensure your hotel/venue has signed a cooperation agreement with Meetingtrips and completed the entry of basic hotel/venue information. If not signed, your registration information will not be approved.',
        text25: 'II. Registration Process',
        text26: '1. Submit personal and professional real-name information',
        text27: '2. Meetingtrips reviews information and confirms with the hotel',
        text28: '3. Account activation',
        text29: 'For hotel/venue partnership, please call:',
        text30: 'Hotel Information',
        text31: 'Registration Information',
        text32: 'Submit Application',
        text33: 'Resident ID Card',
        text34: 'Mainland Travel Permit for Hong Kong and Macao Residents',
        text35: 'Mainland Travel Permit for Taiwan Residents',
        text36: 'Foreign Permanent Resident ID Card',
        text37: 'Please enter name',
        text38: 'Please select gender',
        text39: 'Please select ID type',
        text40: 'Please upload ID front',
        text41: 'Please upload ID back',
        text42: 'Please enter your hotel',
        text43: 'Please enter position',
        text44: 'Please upload business card',
        text45: 'Please upload business license',
        text46: 'Please enter English or numbers',
        text47: 'Please enter password',
        text48: 'Please confirm password again',
        text49: 'Please enter a valid mobile number',
        text50: 'Please enter a valid email',
        text05: 'email',
        text51: 'Confirm password does not match password, please modify and resubmit!',
        text52: 'Submission successful!',
        text53: 'Sent successfully!',
        text54: 'Sending failed, please try again later!',
        text55: 'Country',
        text56: 'Please select',
        text57: 'International region',
        text58: 'domestic',
        text59: 'overseas',
        text60: 'Registration Type',
        text61: 'Will it be limited to venue participation only',
    },
    matchingService: {
        text1: 'When hosting meetings, exhibitions, or celebration events, venue setup is a crucial step. We provide professional venue setup services. With just one call, our team will visit the site for detailed measurements and professional advice. With extensive design and construction experience, we offer one-stop services from design to installation, ensuring seamless integration of every step. Our services not only save clients time and cost but also ensure smooth event execution for optimal results.',
        text2: 'Meetingtrips has years of experience in public relations meetings and event services, achieving efficient utilization at low cost while fully meeting equipment requirements. While perfectly achieving visual effects, we effectively save clients rental and usage costs. Audio equipment is particularly vital in public relations events and business meetings as it guarantees all sound sources on site. Meeting service experts provide customized audio solutions based on venue specifics and meeting nature. Key factors include event venue size, height, meeting format, and content.',
        text3: 'PAR Light',
        text4: 'Generally used for front light, can install different color gels, suitable for live performances. Also known as a can light, its main feature is emitting a relatively fixed beam with various beam angles; spot size is not adjustable.',
        text5: 'Strobe Light',
        text6: 'Generally used for front light, can install different color gels, suitable for live performances.',
        text7: 'Floodlight',
        text8: 'Often used for large-area illumination of scenery and cycloramas; more commonly used outdoors.',
        text9: 'Six-Light Bar',
        text10: 'Commonly used for large-area stage lighting and audience area illumination.',
        text11: 'Backlight',
        text12: 'Large-area stage lighting, commonly used for front light, side light, and backlight.',
        text13: 'Lighting Console',
        text14: 'Programmable, stores information, controls lighting changes, and synchronizes with live event music for performances.',
        text15: 'Scanner Light',
        text16: 'Diverse models and types, rich patterns, mostly used for large-scale performances or concerts.',
        text17: 'Laser Light',
        text18: 'Colorful imaging effects, programmable patterns, mostly used for large-scale performances and events.',
        text19: 'Profile Spotlight / Ellipsoidal Reflector Spotlight (ERS)',
        text20: 'Can create various shaped images, high brightness. Also known as a pattern light or ellipsoidal spotlight. Its main feature is cutting the light beam into shapes like square, diamond, triangle, or projecting various required patterns. Power options include 1KW, 2KW, etc.',
        text21: 'Follow Spot',
        text22: 'Used for close-ups and tracking of people during events, with excellent effects. Mainly highlights performers or special effects with a beam when the entire stage is dark, or provides fill light. Follow spots can change colors and project different patterns. Characteristically requires manual operation to follow performers. Widely used in stage plays, wedding ceremonies, opening/closing ceremonies, etc.',
        text23: 'Moving Head / Intelligent Light',
        text24: 'Various patterns, strobe effects, and other special effects. Can install logo gobos, suitable for performances and various effect coordination. A high-tech professional stage light. Due to its unique light source, complex structure, and diverse effects, stage moving heads are widely used in large stadiums, outdoor performances, theaters, and TV studios, becoming mainstream stage lighting.',
        text25: 'As a core device for displaying visuals and presentation content, projectors have become standard for PR meetings and events. Meetingtrips\'s suppliers have years of PR meeting service experience, understanding the lumen requirements for different meeting types and scales. They tailor recommendations based on the color reproduction capabilities and characteristics of various projector brands, showcasing Meetingtrips experts\' unique expertise. LED displays are suitable for large stadiums, TV broadcasts, exhibition halls, annual meetings, product launches, and performances, displaying changing numbers, text, graphics, and images. Suitable for both indoor and outdoor use, they offer advantages like high brightness, low operating voltage, low power consumption, compact size, long life, impact resistance, and stable performance. When recommending large LED screens, Meetingtrips considers meeting type and seating arrangement to recommend suitable resolution (pixel density), meeting event needs while striving to save costs.',
        text26: 'Lumens',
        text27: 'People',
        text28: 'Suitable Occasion',
        text29: 'Darker environment, best paired with 100-inch screen',
        text30: 'People',
        text31: 'Dim meeting room, best paired with 100-inch/120-inch screen',
        text32: 'Dim meeting room, best paired with screens below 150 inches',
        text33: 'Environment with low natural light, best paired with 150-inch screen',
        text34: 'Environment with low natural light, best paired with screens above 150 inches',
        text35: 'Environment with low natural light, can pair with custom large screens as required',
        text36: 'or large-scale performances',
        text37: 'Professional photography and videography services are key to recording and spreading highlights. We provide high-quality services with an experienced, skilled team capturing every important moment. Whether HD video, photo shooting, or post-production, we offer one-stop services ensuring perfect results. Using advanced equipment and tailored plans based on event needs and venue conditions, we provide optimal visual records and promotional materials.',
        text38: 'Professional DV Camcorder',
        text39: 'Camera Jib Arm',
        text40: 'Sony, Panasonic, etc., 12x, 16x optical zoom',
        text41: 'American Jimmy fully automatic heavy-duty jib arm, adjustable distance 8m, 10m, 12m',
        text42: 'Sony, Panasonic, etc., 12x, 16x optical zoom',
        text43: 'American Jimmy fully automatic heavy-duty jib arm, adjustable distance 8m, 10m, 12m',
        text44: 'Live streaming has become crucial for meetings, forums, exhibitions, and offline events, amplifying their promotional impact. Our experienced team provides professional, cost-effective live streaming technical services and solutions, including photography/videography, directing, and streaming. Using advanced technology, we tailor plans to client needs, offering rich features. Our services include: video packaged streaming, multi-platform streaming, multi-camera live streaming, custom layouts, real-time directing, live subtitles, live scripts, replay, etc. Multi-platform streaming supports public platforms like Video Channel (微信视频号), Xiaohongshu, Douyin (TikTok), and private domain solutions.',
        text45: 'Professional vehicle services are essential for ensuring guests and staff arrive on time and safely. We provide top-tier services with luxury cars, business vans, buses, and more. Our experienced drivers know city roads and venues well, offering punctual, safe, comfortable transfers. Whether VIP pickup, airport transfers, or event transportation, we provide customized solutions ensuring smooth events and enhancing the overall experience.',
        text46: 'Brand',
        text47: 'Model',
        text48: 'Passenger Capacity',
        text49: 'Vehicle Configuration',
        text50: 'Design and planning are core to event success. We offer comprehensive services, from concept to execution, creating unique, attractive event plans. Our team of experienced designers and planners tailors solutions to client needs and goals, covering visual style, layout, and theme. We focus on details, ensuring every element aligns with the theme while considering functionality and audience experience. Our goal is to elevate events through professional design.',
        text51: 'Translation services are vital for smooth cross-language communication. We provide professional services including simultaneous interpretation, consecutive interpretation, and document translation. Our experienced linguists have industry knowledge and ensure accurate, efficient support for any event. Whether international conferences, business talks, or multilingual presentations, we ensure clear communication.',
        text52: 'Performers and programs are key to engaging audiences and enhancing atmosphere. We offer high-level performance services covering dance, music, theater, talk shows, etc. Our professional artists have rich experience and tailor programs to event themes and audiences. We ensure every performance is perfect, adding highlights and vitality.',
        text53: 'Protocol services are essential for professional image and smooth event flow. We provide comprehensive services including reception, ushering, and protocol staff. Our trained team offers warm, attentive service, ensuring every guest feels respected. Whether registration, guiding, or onsite coordination, we tailor services to event needs, enhancing quality and experience.',
        text54: 'For annual meetings or celebrations, meticulous protocol services enhance the formal atmosphere. Our trained team warmly welcomes guests and handles contingencies. For large galas, company events, or private parties, we tailor solutions for memorable, efficient celebrations.',
        text55: 'For forums, quality protocol ensures smooth proceedings and professionalism. Whether opening ceremonies, roundtables, or closing speeches, we tailor services to ensure smooth forums and elevate the experience.',
        text56: 'For brand promotion and launches, quality protocol boosts professionalism and image. Whether launches, product demos, or media events, we tailor solutions to help shape your brand image and enhance event impact.',
        text57: 'Beautiful floral decorations enhance venue ambiance and visual appeal. We provide professional services, from design to setup, creating unique, elegant environments. Our experienced floral designers craft stunning works based on theme, venue, and client needs. Whether stage decor, reception areas, or table arrangements, we tailor solutions ensuring every detail is perfect, adding color and class.',
        text58: 'High-quality printed materials are key for information display and event image. We provide professional printing services: conference manuals, brochures, business cards, posters, banners, etc. Our team has rich design and print experience, using advanced equipment and quality materials for excellent visuals and feel. Whether brand materials, event guides, or promotional posters, we offer customized solutions to best convey information and elevate your event image.',
        text59: 'Custom gifts are excellent for expressing thanks and enhancing event memorability. We provide professional gift customization: corporate gifts, souvenirs, prizes, etc. Our team has design expertise and supply chain resources, offering unique, meaningful gifts based on client needs and themes. Whether premium gift boxes, custom stationery, branded souvenirs, or creative items, we tailor solutions ensuring each gift conveys sincerity, boosts brand image, and adds value to your event.',
        text60: 'Based on client historical data, Meetingtrips provides more background information to increase closing rates and enhance service quality.',
        text61: 'For client needs, please call',

        text62: 'Venue Setup',
        text63: 'Audio & Lighting',
        text64: 'Video & Projection',
        text65: 'Photography & Videography',
        text66: 'Live Streaming Services',
        text67: 'Vehicle Services',
        text68: 'Design & Planning',
        text69: 'Translation Services',
        text70: 'Performers & Programs',
        text71: 'Protocol Services',
        text72: 'Floral Decoration',
        text73: 'Printing Materials',
        text74: 'Gift Customization',

        text75: 'Yutong Coach',
        text76: 'Large Coach',
        text77: 'Seats',
        text78: 'Based on client historical data, Meetingtrips provides more background information to increase closing rates and enhance service quality.',
        text79: 'Medium Coach',
        text80: 'High-back soft seats, A/C & heating, premium sound, LCD TV, 6-disc VCD, large luggage compartment, ABS.',
        text81: 'High-back soft seats, A/C & heating, premium sound, large luggage compartment, ABS.',
        text82: 'High-back soft seats, A/C & heating, premium sound.',
    },
    userPage_address: {
        text1: 'Add Address',
        text2: 'Name',
        text3: 'Mobile Number',
        text4: 'Region',
        text5: 'Detailed Address',
        text6: 'Please enter name',
        text7: 'Please enter mobile number',
        text8: 'Please select region',
        text9: 'Please enter detailed address',
        text10: 'Cancel',
        text11: 'Confirm',
        text12: 'Option',
        text13: 'Edit',
        text14: 'Delete',
        deleteSuccess: 'Delete Success',
        updateSuccess: 'Update Success',
        addSucccess: 'Add Succcess',
    },
    userPage_detail: {
        text1: 'Order Status',
        text2: 'Conference Coordinator',
        text3: 'Order Number',
        text4: 'Order Time',
        text5: 'Quotation List',
        text6: 'Hotel Name',
        text7: 'Meeting Room',
        text8: 'Venue Price',
        text99: 'Dining',
        text9: 'Dining Price',
        text1010: 'Accommodation',
        text10: 'Accommodation Price',
        text11: 'Hotel Remarks',
        text12: 'Action',
        text13: 'Requirement Information',
        text14: 'Event City',
        text15: 'Event Time',
        text16: 'Number of Attendees',
        text17: 'Event Budget',
        text18: 'Event Type',
        text19: 'Event Requirements',
        text20: 'Personal Information',
        text21: 'Contact Person',
        text22: 'Mobile Number',
        text23: 'Company Name',

        text24: 'Full-day Price',
        text25: 'Half-day Price',
        text26: 'Led Width',
        text27: 'Led Height',
        text28: 'Venue setup costs',
        text29: 'Venue setup description',
        text30: 'Dining type',
        text31: 'Dining price',
        text32: 'Adopted',
        text33: 'Not adopted',
        text34: 'Room type',
        text35: 'Room price',
        text36: 'Adopt',
    },
    userPage_home: {
        text0: 'Current Points',
        text1: 'Edit Profile',
        text2: 'Points Mall',
        text3: 'Points Orders',
        text4: 'Customer Addresses',
        text5: 'No Orders Yet',
        text6: 'Order Number',
        text7: 'Posted On',
        text8: 'Budget',
        text9: 'People',
        text10: 'Event City',
        text11: 'Event Type',
        text12: 'Event Date',
        text13: 'Event Requirements',
        text14: 'Waiting to Obtain Venue Plan (Includes Availability & Quote)',
        text15: 'The consultant has invited hotels to quote. Carefully selecting 3-6 venue plans for you in about 25 minutes.',

        text16: 'View Quoted List and Details',

        text17: 'My Information',
        text18: 'Personal Information',
        text19: 'Address Management',
        text20: 'My Orders',
        text21: 'Hotel Orders',
        text22: 'Supporting Service Orders',
        text23: 'Points Mall',
        text24: 'Points Redemption',
        text25: 'Points Orders',
        text26: 'Points Rules',
        text27: 'Points Details',
        text28: 'After-sales Service',
        text29: 'Invoice Issuance',
        text30: 'Confirm to log out?',
        text31: 'Log Out',
    },
    userPage_infoPage: {
        text1: 'Your Information',
        text2: 'Name',
        text3: 'Please enter name',
        text4: 'Gender',
        text5: 'Please select gender',
        text6: 'Male',
        text7: 'Female',
        text8: 'Unknown',
        text9: 'Birthday',
        text10: 'Please select birthday',
        text11: 'Email',
        text12: 'Please enter email',
        text13: 'Please enter QQ number',
        text14: 'WeChat ID',
        text15: 'Please enter WeChat ID',
        text16: 'Company Name',
        text17: 'Please enter company name',
        text18: 'Department',
        text19: 'Please select department',
        text20: 'Your Position',
        text21: 'Please select position',
        text22: 'Submit'
    },
    userPage_login: {
        text1: 'Meetingtrips',
        text2: 'Customer Management System',
        text3: 'One-Stop Meeting Service Platform',
        text4: 'Hello!',
        text5: 'Welcome to the Meetingtrips Customer Management System',
        text6: 'Phone',
        text7: 'Verification code',
        text8: 'Login',
        text9: 'Send',
        text10: 'Please enter mobile number and get verification code first',
        text11: 'Resend',
    },
    userPage_shop: {
        text1: 'Points Price',
        text2: 'All',
    },
    userPage_shopDetail: {
        text1: 'Points Price',
        text2: 'Remaining Quantity',
        text3: 'Order Quantity',
        text4: 'Description',
        text5: 'Select Address',
        text6: 'Please Select',
        text7: 'Verification Code',
        text8: 'Purchase',
        text9: 'Send',
        text10: 'Order Placed Successfully',

        text11: 'Please select address',
        text12: 'Please enter verification code',
        text13: 'Confirm order?',
        text14: 'Cancel button clicked',
        text15: 'Clicking confirm will send a verification code to your mobile number ({phoneNumber}). Send?',
        text16: 'Insufficient points',
    },
    userPage_waresOrder: {
        text1: 'Product Name',
        text2: 'Type',
        text3: 'Order Number',
        text4: 'Mobile Number',
        text5: 'Address',
    },
    Index_page: {
        text1: 'Release Requirements',
        text2: 'Meeting consultant 1-on-1',
        text03: 'Is it an international order?',
        text3: 'Where do you want to hold the event?',
        text4: 'Try searching: Guide',
        text5: 'What kind of event?',
        text6: 'Event Date',
        text7: 'Select Date',
        text8: 'Event Duration',
        text9: 'Number of Attendees',
        text10: 'Approximate Budget',
        text11: 'Your Project Requirements',
        text12: 'Need other supporting services like advertising planning, stage setup',
        text13: 'Free Venue Matching',
        text14: '1 Minute',
        text15: 'Release Meeting Requirements',
        text16: '10 Minutes',
        text17: 'Meeting Consultant Calls',
        text18: '30 Minutes',
        text19: 'Get Meeting Plan',
        text20: 'Go Back to Modify Requirements',
        text21: 'Please Confirm Your Event',
        text22: 'You want to hold a',
        text23: 'in',
        text24: 'Starting on',
        text25: 'Duration',
        text26: 'Attendees',
        text27: 'Budget',
        text28: 'Including',
        text29: 'and other event requirements',
        text30: 'Please enter your mobile number to receive venue plans and quotes',
        text31: 'Get Verification Code',
        text32: 'Get Venue Quotes & Availability for Free',
        text33: 'Submitting meeting requirements means agreeing to',
        text34: '《Meetingtrips User Agreement》',
        text35: '《Privacy Protection Policy》',
        text36: 'The Purpose of Using Meetingtrips',
        text37: 'Efficiently Match Ideal Venues',
        text38: 'Directly connected to global hotels and unique meeting venues. Release meeting info with one click, get quotes fast.',
        text39: 'System intelligent search & inquiry, higher venue cost-effectiveness',
        text40: 'Platform compares meeting venue prices, discounts over 30%+',
        text41: 'Facilitate Meeting Equipment & Support Services',
        text42: 'One-stop platform for stage design, planning, setup, materials, vehicles, tickets, etc.',
        text43: 'Users register and use the platform for free',
        text44: 'Online & offline meeting consultants provide 1-on-1 service',
        text45: 'Offline Meeting Services More Professional',
        text46: 'Platform matches venues online, offline professional services more attentive',
        text47: 'Great Places for Events Nationwide',
        text48: 'Selected Meeting Venues',
        text49: 'Venue Area',
        text50: 'Popular Meeting Hotels',
        text51: 'Largest Venue Area',
        text52: 'Great Places for Events Around the City',
    },
    activityDetail: {
        text1: 'Booking Notes', // 活动说明标题
        text2: 'Expand', // 展开按钮文案
        text3: 'Collapse', // 收起按钮文案
        text4: 'Technical support by HUIZHIXING', // 底部技术支持文字
        text5: 'Activity not found, please enter from the correct entrance', // 缺少活动ID提示
        text6: 'Loading...', // 加载中文案
        text7: 'Click to retry', // 重试按钮文案
        text8: 'Failed to load activity information', // 加载失败文案
    }
};